import {Button, ButtonGroup, DialogBody, DialogFooter, Stack, Text, Textarea} from "@chakra-ui/react";
import {Form, UI} from "components";
import {toaster} from "config";
import {API} from "config";
import useOrder from "hooks/useOrder";
import {useState} from "react";

export default function Cancel({data = {}, ...props}) {

    const order = useOrder(data?.id)
    const [loading, setLoading] = useState(false)
    const [canceled_reason, setCanceledReason] = useState('')

    const handleCancel = async () => {
        if (!window.confirm('Tem certeza que deseja cancelar este pedido?')) return
        setLoading(true)

        try {
            await API.post(`/orders/${order?.data?.id}/cancel`, {canceled_reason, _method: 'put'})
            toaster.create({title: 'O pedido foi cancelado', type: 'info'})
            order.refetch()
            props.onClose()
        } catch (err) {
            toaster.create({
                title: 'Não foi possível cancelar o pedido',
                description: err?.response?.data?.message,
                type: 'warning'
            })
        }

        setLoading(false)
    }

    return (
        <UI.Dialog loading={loading} size="sm" title={`Cancelar pedido #${order.data?.cod}?`} {...props}>
            <DialogBody>
                <Stack gap={3}>
                    <Text fontSize="sm">O cancelamento de um pedido é uma ação irreversível. No momento da cancelamento,
                        os pagamentos serão cancelados/devolvidos e o status do pedido passará a ser <b>Cancelado</b> e
                        os produtos reservados retornarão ao estoque.</Text>
                    <Text>Tem certeza que deseja prosseguir com o cancelamento?</Text>

                    <Textarea disabled={loading} placeholder="Informe o motivo do cancelamento..."
                              value={canceled_reason} onChange={e => setCanceledReason(e.target.value)}/>
                </Stack>
            </DialogBody>
            <DialogFooter>
                <ButtonGroup>
                    <Button loading={loading} loadingText="Cancelando pedido..." variant="subtle" colorPalette="orange"
                            onClick={handleCancel}><UI.Icon name="cancel"/> Cancelar pedido</Button>
                    <Button disabled={loading} variant="ghost" onClick={props.onClose}>Fechar</Button>
                </ButtonGroup>
            </DialogFooter>
        </UI.Dialog>
    )
}